import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteWorkspaceFeedback } from "api/services/workspace-service";
import { WORKSPACE_FEEDBACK_QUERY_KEY } from "hooks/feedback/queryKeys";
import { useAuthContext } from "@hooks/useAuthContext";

export const useDeleteWorkspaceFeedback = () => {
    const queryClient = useQueryClient();
     const { userState } = useAuthContext();

    const mutation = useMutation({
        mutationFn: async (feedbackId: string): Promise<void> => {
            const response = await deleteWorkspaceFeedback({ workspaceId: userState.user.selectedWorkspace.workspaceId, feedbackId });
            if (response?.success === false) {
                throw new Error(response?.message ?? "feedbackManagement.deleteError");
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: WORKSPACE_FEEDBACK_QUERY_KEY });
        }
    });

    return {
        deleteFeedback: mutation.mutateAsync,
        deletingFeedback: mutation.isPending,
    };
};
